import React from 'react';

import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import UpdateExternalJobBoardForm from './UpdateExternalJobBoardForm';

import { useExternalJobBoardsState, useExternalJobBoardsActions } from './ExternalJobBoardsContext';

const UpdateExternalJobBoardModal = () => {
  const externalJobBoardsState = useExternalJobBoardsState();
  const { closeUpdateExternalJobBoardModal } = useExternalJobBoardsActions();

  return (
    <StandardModal
      isOpen={externalJobBoardsState?.updateExternalJobBoardModalIsOpen}
      contentLabel={'Update External Job Board'}
      onRequestClose={() => {
        closeUpdateExternalJobBoardModal();
      }}
    >
      <PageTitle text={'Update External Job Board'} />
      <UpdateExternalJobBoardForm />
    </StandardModal>
  );
};

export default UpdateExternalJobBoardModal;